var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54167",
    "data-name": "Group 54167",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54150",
    "data-name": "Group 54150",
    transform: "translate(1.545 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329",
    "data-name": "Rectangle 5329",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330",
    "data-name": "Rectangle 5330",
    width: 2.091,
    height: 2.091,
    transform: "translate(1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331",
    "data-name": "Rectangle 5331",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 3.091)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332",
    "data-name": "Rectangle 5332",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333",
    "data-name": "Rectangle 5333",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182 7.727)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 2.091,
    height: 2.091,
    transform: "translate(9.273 10.818)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5376",
    "data-name": "Rectangle 5376",
    width: 2.091,
    height: 2.091,
    transform: "translate(10.818 12.363)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5377",
    "data-name": "Rectangle 5377",
    width: 2.091,
    height: 2.091,
    transform: "translate(12.363 13.909)",
    fill: "#15081f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54151",
    "data-name": "Group 54151",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329-2",
    "data-name": "Rectangle 5329",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330-2",
    "data-name": "Rectangle 5330",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331-2",
    "data-name": "Rectangle 5331",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 3.091)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332-2",
    "data-name": "Rectangle 5332",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333-2",
    "data-name": "Rectangle 5333",
    width: 2.091,
    height: 2.091,
    transform: "translate(1.545 7.727)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5373",
    "data-name": "Rectangle 5373",
    width: 2.091,
    height: 2.091,
    transform: "translate(3.091 9.273)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5374",
    "data-name": "Rectangle 5374",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182 9.273)",
    fill: "#15081f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGe);
export default __webpack_public_path__ + "static/media/search-ge.ac71b11bb5759746789772848e0ae6ce.svg";
export { ForwardRef as ReactComponent };